import { Product } from "@/@core/entity/product.entity";
import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface GetProductDTO {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
  status?: number;
  category?: string;
  with_media?: number;
}

export type GetUsetResp = BaseResAPI<Product[]>;

const getProductInteractor = (params: GetProductDTO): Promise<GetUsetResp> => {
  const path = `/admin/product`;

  const { page, limit, sort, search, status, category, with_media } = params;
  let pathParam = "?";
  if (page) pathParam += `&page=${page}`;
  if (limit) pathParam += `&limit=${limit}`;
  if (sort) pathParam += `&sort=${sort}`;
  if (search) pathParam += `&search=${search}`;
  if (status) pathParam += `&status=${status}`;
  if (category) pathParam += `&category=${category}`;
  if (with_media) pathParam += `&with_media=${with_media}`;

  return api.get(pathParam === "?" ? path : path + pathParam);
};

export default getProductInteractor;
